import { useState } from 'react';

import { Button } from '@/design-system';
import { OrganizationBillingSchema, PaymentPlanTier } from '@/types/schema';

import { isCancelledPlan } from '../utils/isCancelledPlan';
import { CancelSubscriptionModal } from './CancelSubscription';

export function CancelButton(props: {
  endOfBillingPeriod?: string;
  currentOrganization: OrganizationBillingSchema;
  currentTier?: PaymentPlanTier | null;
  isPersonal: boolean;
}) {
  const currentPlan = props.currentOrganization.current_plan;
  const upcomingPlan = props.currentOrganization.upcoming_plan;
  const hasCancelled = isCancelledPlan(currentPlan, upcomingPlan);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const isDeveloper = props.currentTier === 'developer';

  const cancelSubscription = props.currentTier &&
    props.currentOrganization.end_of_billing_period &&
    !hasCancelled &&
    props.currentTier !== 'developer_legacy' &&
    props.currentTier !== 'plus_legacy' && (
      <Button
        variant="outlined"
        color="error"
        size="sm"
        onClick={() => {
          setIsCancelModalOpen(true);
        }}
      >
        {isDeveloper ? 'Remove payment method' : 'Cancel subscription'}
      </Button>
    );

  return (
    <>
      {cancelSubscription}
      <CancelSubscriptionModal
        open={isCancelModalOpen}
        onClose={() => setIsCancelModalOpen(false)}
      />
    </>
  );
}
